/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquarePowerpoint: {
  name: 'square-powerpoint';
  data: string;
} = {
  name: 'square-powerpoint',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm0 2h16v16H4V4Zm7 4a2 2 0 0 0-2 2v5a1 1 0 1 0 2 0v-1h2a3 3 0 1 0 0-6h-2Zm2 4h-2v-2h2a1 1 0 1 1 0 2Z" fill="currentColor"/></svg>`,
};
